module.exports = __webpack_public_path__ + "images/icons/icon-exchange-arrows-5d295230.svg";